import './nps.css';




export const NPSScore = ({ score, onScoreChange, className = "" }) => {

  const getButtonStyles = (buttonScore, isSelected) => {

    console.log(buttonScore, isSelected);
    
    if (isSelected) {
      if (buttonScore <= 6) {
        return {backgroundColor: 'red', color: '#fff'};
      } else if (buttonScore <= 8) {
        return {backgroundColor: 'orange', color: '#fff'};
      } else {
        return {backgroundColor: 'green', color: '#fff'};
      }

    } else {
      return {backgroundColor: '#fff', color: '#000'};
    }
  };


  return (
    <div className={`nps-container ${className}`}>
      <div className="nps-buttons">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => {
          const isSelected = score === num;
          const level = num <= 6 ? "low" : num <= 8 ? "mid" : "high";

          const btnStyle = getButtonStyles(score, isSelected);

          console.log('BUTTON STYLE:', btnStyle);

          return (
            <button
              key={num}
              type="button"
              onClick={() => onScoreChange(num)}
              style={btnStyle}
              className={`nps-button ${level} ${
                isSelected ? `selected-${level}` : ""
              }`}
            >
              {num}
            </button>
          );
        })}
      </div>
      <div className="nps-labels">
        <span>Pouco provável</span>
        <span>Muito provável</span>
      </div>
    </div>
  );
};
